import { Button, TextField } from '@mui/material'
import React from 'react'
import { Controller, FormProvider, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface AddPipelineFormProps {
    onSubmit: (data: any) => void
}

export const AddPipelineForm = ({ onSubmit }: AddPipelineFormProps) => {
    const { t } = useTranslation()
    const methods = useForm({
        defaultValues: {
            name: '',
            color: '#000000',
        },
        mode: 'onChange',
    })
    return (
        <div>
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit)}>
                    <div className='flex gap-4 mt-4'>
                        <TextField label={t('pipelines.name')} fullWidth {...methods.register('name', {
                            required: true
                        })} autoComplete='off' required />
                        {/* <Controller control={methods.control} name="color" render={({ field }) => {
                            return <input type="color" {...field} value={field.value || '#000000'} />
                        }} /> */}
                    </div>
                    <div className='mt-4'>
                        <Button variant="contained" color="primary" type="submit" disabled={!methods.formState.isValid}>Добавить</Button>
                    </div>
                    {/* <pre>{JSON.stringify(methods.getValues(), null, 2)}</pre> */}
                </form>
            </FormProvider>
        </div>
    )
}
